<template>
  <v-container id="objects-list" class="pa-0">
    <HomeDesktopImagesSlider v-if="homepage && $vuetify.breakpoint.mdAndUp" />
    <ListTopFilters />
    <MobileFiltersPlaceholder />
    <v-row
      dense
      :style="isMobileView ? 'margin-top: -10px !important;' : ''"
    >
      <ListObject
        v-for="(object, index) in searchResult"
        :key="index"
        :object="object"
      />
      <span v-if="searchResult && searchResult.length === 0" class="px-5">
        <h1><b>{{ $t('objekte_ei_leitud') }}</b></h1>
      </span>
    </v-row>
    <ListPagination />
  </v-container>
</template>

<script>
import sharedMethods from '../../methods/sharedMethods'
import HomeDesktopImagesSlider from '@/components/Views/Home/HomeDesktopImagesSlider'
import sharedComputed from '@/methods/sharedComputed'
import MobileFiltersPlaceholder from '@/components/List/MobileFiltersPlaceholder'
import ListPagination from '@/components/List/ListPagination'
import ListObject from '@/components/List/ListObject/ListObject'

import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
import ListTopFilters from '@/components/List/ListTopFilters'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'List',

  data () {
    return {
      filtersOffsetTop: 0,
    }
  },

  components: {
    ListTopFilters,
    ListObject,
    ListPagination,
    MobileFiltersPlaceholder,
    HomeDesktopImagesSlider,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
  },

  watch: {
    sortBy () {
      if (this.searchFilters.page !== 1) {
        this.searchFilters.page = 1
      } else {
        this.searchObjects(true)
      }
    },
    page () {
      // Scroll to top first, otherwise scroll to search position
      // not working on Android
      // For mobile this happens inside searchObjects
      if (this.$vuetify.breakpoint.smAndDown) {
        window.scrollTo(0, 0)
      }
      this.$nextTick(() => {
        this.searchObjects(!this.homepage)
        // Always scroll instantly, otherwise Safari issues
        if (!this.$vuetify.breakpoint.smAndDown) {
          window.scrollTo({
            top: 0,
            left: 0,
            // behavior: 'smooth'
          })
        }
      })
    },
  },

  methods: {
    ...sharedMethods,
  },
}
</script>
